import _ from "lodash";
import moment from "moment";
import { useCallback, useEffect, useMemo, useState } from "react";
import { changeRecieve, getPaymentNCancelList } from "src/api/billingSchedule/billingSchedule-api";
import { getProviderAccountCredits } from "src/api/contract/contract-api";
import { useApiOperation } from "src/api/hooks";
import { BaseButton, BaseModal } from "src/components";
import { BaseAbstractModal } from "src/components/BaseAbstractModal";
import RangeDatepicker from "src/components/RangeDatepicker";
import { useToast } from "src/recoil/toast/hook";
import { ViewYmdFormat, YmdFormat } from "src/utils/common-util";
import DepositHistoryTable from "./DepositHistoryTable";
import PriceInfo from "./PriceInfo";
import StorageProcessingTable from "./StorageProcessingTable";
import PaymentTable from "./PaymentTable";
import { CtPayment } from "src/api/contract/contract-types";

interface ProcessDatas {
  row: any;
  rows: any;
  callList: any;
  contractBaseInfo: any;
  buildingId?: any;
  scheduleId: any;
  showBtn: boolean;
  isChange: boolean;
  setIsChange: any;
  type: string;
}
interface Props {
  processData: ProcessDatas;
}

const StorageProcessingModal = ({ processData }: Props) => {
  const { contractBaseInfo, row, callList, scheduleId, showBtn, isChange, setIsChange, buildingId, type } = processData;

  const { executeAsync: changeSuccess } = useApiOperation(changeRecieve);
  const { executeAsync: getAccountCredits } = useApiOperation(getProviderAccountCredits);
  const { executeAsync: getPaymentList } = useApiOperation(getPaymentNCancelList);

  const { openToast } = useToast();
  const [dateRange, setDateRange] = useState<[Date | null, Date | null]>([null, null]);

  const [search, setSearch] = useState({
    billId: Number(row.original.bill.billId),
    scheduleId: scheduleId,
    startDateTime: "",
    endDateTime: "",
  });
  // const sorted = _.sortBy(sample, "trDateTime").reverse();
  const [receiveData, setReceiveData] = useState<any>([]);

  const [receiveList, setReceiveList] = useState<any>([]);
  const [delReceiveList, setDelReceiveList] = useState<any>([]);
  const [paymentArray, setPaymentArray] = useState<CtPayment[]>([]);

  const [isSave, setIsSave] = useState(false);
  const [isSaved, setIsSaved] = useState(false);
  const [message, setMessage] = useState("");

  const [maxLimit, setMaxLimit] = useState<Date | null>(null);

  const [sum] = useState(0);
  const [ovSum] = useState(0);

  const fetchAccounts = async (search: any) => {
    const response: any = await getAccountCredits(search).catch(() => undefined);

    if (response) {
      response.data.data.content.forEach((accData: any) => (accData.isOpen = false));
      setReceiveData(response.data.data.content);
    }
  };

  const fetchPaymentList = async (billId: string, pgcode: string) => {
    let params = {
      billId,
      pgcode,
      isSuccessOnly: true,
    };
    if (pgcode === "virtualaccount") {
      params.isSuccessOnly = false;
    }
    const paymentList = await getPaymentList(params);
    if (paymentList.data.data.content && paymentList.data.data.content.length > 0) {
      const result: CtPayment[] = paymentList.data.data.content.map((item: any) => ({
        ...item,
        subRows: item.cancelList,
      }));
      setPaymentArray(result);
    }
  };

  const validation = (List: any) => {
    let checkPrice = true;
    let checkDate = true;
    let checkPgcode = true;

    if (Number(makeSum) > Number(row.original.receiptBundle.billTotalAmount)) {
      openToast({ content: "입금 총액은 수납처리 전 잔액보다 클 수 업습니다.", isSystemToast: true });
      return;
    }

    const saveList = List.filter((save: any) => Number(save.receiptId) === 0);

    saveList.forEach((save: any) => {
      if (save.pgcode === "" || save.pgcode === undefined || save.pgcode === null) {
        checkPgcode = false;
      }
      if (save.trDateTime === undefined || save.trDateTime === null) {
        checkDate = false;
      }
      if (Number(save.receiptAmount) === 0) {
        checkPrice = false;
      }
    });

    if (!checkPgcode) {
      openToast({ content: "결제수단을 선택해 주세요.", isSystemToast: true });
      return;
    }

    if (!checkPrice) {
      openToast({ content: "수납 추가 시 수납 금액은 필수 입력 정보입니다.", isSystemToast: true });
      return;
    }
    if (!checkDate) {
      openToast({ content: "수납 추가 시 거래일시는 필수 입력 정보입니다.", isSystemToast: true });
      return;
    }

    const etc = List.filter((save: any) => Number(save.acctCreditId) === 0 && Number(save.paymentId) === 0 && Number(save.receiptId) === 0);
    const accounts = List.filter((save: any) => Number(save.acctCreditId) !== 0 || (Number(save.paymentId) !== 0 && Number(save.receiptId) === 0));

    if (row.original.bill.pgcode === "creaditcard" && Number(row.original.receiptBundle.billTotalAmount) !== Number(etc.receiptAmount)) {
      openToast({ content: "카드결제형은 부분수납을 허용하지 않습니다.", isSystemToast: true });
      return;
    }
    accounts.forEach((save: any) => {
      save.trDateTime = moment(save.trDateTime).format(YmdFormat.WITH_TIME_ZONE);
    });
    let sendData: any = [];
    let etcs: any = [];
    etc.forEach((addItem: any) => {
      if (addItem && addItem.trDateTime !== null && addItem.receiptAmount !== 0) {
        const insertReceipt: any = {
          receiptId: 0,
          billId: row.original.bill.billId,
          acctCreditId: 0,
          paymentId: 0,
          pgcode: addItem.pgcode,
          receiptAmount: Number(etc.receiptAmount),
          trDateTime: moment(etc.trDateTime).format(YmdFormat.WITH_TIME_ZONE),
        };
        etcs.push(insertReceipt);
      }
    });
    sendData = [...accounts, ...etcs, ...delReceiveList];

    if (sendData.length === 0) {
      openToast({
        content: "저장 내용이 없습니다. 수납 내역을 입력해주세요",
        isSystemToast: true,
      });
      return;
    }

    if (checkPrice) {
      setMessage("저장 하시겠습니까?");
      setIsSave(true);
    }
  };

  // const firstSettings = () => {
  //   const listWithViewCount = row.original.receiptBundle.receiptList.map((item: any, index: number) => ({
  //     ...item,
  //     viewCount: index + 1,
  //   }));
  //   setReceiveList(listWithViewCount);
  // };

  const makeSuccess = useCallback(
    async (List: any, del: any) => {
      const etcs = List.filter((save: any) => Number(save.receiptId) === 0);

      let etc: any = [];
      etcs.forEach((addItem: any) => {
        if (addItem && addItem.trDateTime !== null && addItem.receiptAmount !== 0) {
          const insertReceipt: any = {
            receiptId: 0,
            billId: row.original.bill.billId,
            acctCreditId: addItem.acctCreditId !== 0 ? addItem.acctCreditId : 0,
            paymentId: 0,
            pgcode: addItem.pgcode,
            receiptAmount: Number(addItem.receiptAmount),
            trDateTime: moment(addItem.trDateTime).format(YmdFormat.WITH_TIME_ZONE),
          };
          etc.push(insertReceipt);
        }
      });
      etc = etc.concat(del);

      if (etc.length > 0) {
        const send: any = {
          scheduleId: Number(scheduleId),
          body: etc,
        };
        setIsSave(false);
        setIsChange(false);
        await changeSuccess(send);

        openToast({ content: "저장 되었습니다.", isSystemToast: true });

        if (type === "schedule") {
          await callList(scheduleId);
        } else {
          await callList(buildingId, scheduleId);
        }

        // firstSettings();
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [row.original.bill.billId, scheduleId, changeSuccess, setIsChange, callList],
  );

  const sortedRecevieList = useMemo(() => {
    if (receiveList.length === 0) return [];

    const isReceiptId = receiveList.filter((item: any) => Number(item.receiptId) === 0);
    const isReceiptId2 = receiveList.filter((item: any) => Number(item.receiptId) > 0);

    const sorted1 = _.orderBy(isReceiptId, [(receipt: any) => moment(receipt.trDateTime).toDate()], ["desc"]);
    const sorted2 = _.orderBy(isReceiptId2, [(receipt: any) => moment(receipt.trDateTime).toDate()], ["desc"]);

    return [...sorted1, ...sorted2];
  }, [receiveList]);

  const handleOnDateRangeChange = (dateRange: [Date | null, Date | null]) => {
    setDateRange(dateRange);
    let startTime = "";

    let endTime = "";
    if (dateRange[0]) {
      startTime = moment(dateRange[0]).startOf("day").format(YmdFormat.WITH_TIME_ZONE_MILLIS);
      setSearch({ ...search, ...{ startDateTime: startTime } });

      if (moment().isAfter(moment(dateRange[0]).add(3, "months"))) {
        setMaxLimit(moment(dateRange[0]).add(3, "months").toDate());
      } else {
        setMaxLimit(moment().toDate());
      }
    }
    if (dateRange[1]) {
      endTime = moment(dateRange[1]).endOf("day").format(YmdFormat.WITH_TIME_ZONE_MILLIS);
      setSearch({ ...search, ...{ endDateTime: endTime } });
    }

    if (dateRange[0] !== null && dateRange[1] !== null) {
      fetchAccounts({ ...search, ...{ startDateTime: startTime }, ...{ endDateTime: endTime } });
    }
  };

  const callPaymentList = async () => {
    // 모달이 열려있을 때는 callList를 호출하지 않음 (테이블 리렌더링으로 모달이 닫히는 것을 방지)
    // callList는 모달이 닫힐 때나 저장 후에만 호출됨
    await fetchPaymentList(row.original.bill.billId, row.original.bill.pgcode);
    // firstSettings();
  };

  // 데이터 초기화
  const getAccountAndPaymentInfo = useCallback(async () => {
    const now = moment();
    const startDate = now.format(ViewYmdFormat.YYYY_MM_DD);
    const endDate = now.format(ViewYmdFormat.YYYY_MM_DD);

    const startDateTime = moment(`${startDate} 00:00:00`).subtract(7, "days").format(YmdFormat.WITH_TIME_ZONE);
    const endDateTime = moment(`${endDate} 23:59:59`).format(YmdFormat.WITH_TIME_ZONE);

    const updatedSearch = {
      ...search,
      startDateTime,
      endDateTime,
    };

    const updatedDateRange: [Date, Date] = [moment(startDateTime).toDate(), moment(endDateTime).toDate()];

    setMaxLimit(now.toDate());
    setSearch(updatedSearch);
    setDateRange(updatedDateRange);
    setDelReceiveList([]);

    await fetchAccounts(updatedSearch);
    await callPaymentList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [row.original.bill.billId, scheduleId]);

  useEffect(() => {
    getAccountAndPaymentInfo();
  }, [getAccountAndPaymentInfo]);

  useEffect(() => {
    const receiptList = row.original.receiptBundle.receiptList;
    const listWithViewCount = receiptList.map((item: any, index: number) => ({
      ...item,
      viewCount: index + 1,
    }));
    setReceiveList(listWithViewCount);
  }, [row.original.receiptBundle?.receiptList]);

  const makeSum = useMemo(() => {
    const receiptTotal = receiveList.reduce((acc: number, rp: any) => acc + Number(rp.receiptAmount), 0);
    return sum + receiptTotal;
  }, [receiveList, sum]);

  const makeOvSum = useMemo(() => {
    const overdueTotal = receiveList.reduce((acc: number, rp: any) => acc + Number(rp.overdueAmount), 0);
    return ovSum + overdueTotal;
  }, [receiveList, ovSum]);
  const totalSum = useMemo(() => {
    let realtimeOverdueAmount = 0;

    if (row.original.receiptBundle.realtimeOverdueAmount !== undefined) {
      realtimeOverdueAmount += Number(row.original.receiptBundle.realtimeOverdueAmount);
    }

    if (row.original.receiptBundle.accruedOverdueAmount !== undefined) {
      realtimeOverdueAmount += Number(row.original.receiptBundle.accruedOverdueAmount);
    }

    return realtimeOverdueAmount;
  }, [row.original.receiptBundle]);

  const nowSum = useMemo(() => {
    let sum = 0;

    sum = Number(row.original.receiptBundle.billTotalAmount) - makeSum;
    return sum;
  }, [row, makeSum]);

  return (
    <BaseAbstractModal isOpen={isChange} className="billing-schedule-info-modal">
      <section className="base-abstract-modal__title border-bottom">
        <h1>빌링/수납 처리</h1>
      </section>
      <article className="base-abstract-modal__contents px30 overflow-x-hidden">
        <div className="overflow-container">
          {/* 요약 */}
          <PriceInfo spaceProductType={contractBaseInfo?.product?.productType} row={row} nowSum={nowSum} makeSum={makeSum} totalSum={totalSum} />
          {/* 입금 내역 */}
          {type !== "mnt" && row.original.bill.pgcode === "banktransfer" && (
            <section>
              <div className="base-abstract-modal__contents-subtitle">
                <div className="flex-center">
                  <h2>입금내역</h2>
                  <p className="font14 pl10">총 {receiveData.length} 건</p>
                </div>

                <div className="minmax240">
                  <RangeDatepicker
                    disabled={!showBtn}
                    dateRange={dateRange}
                    onChange={handleOnDateRangeChange}
                    maxDate={maxLimit}
                    showClearButton={false}
                  />
                </div>
              </div>
              <DepositHistoryTable
                dataBundle={{
                  tdData: receiveData,
                  setReceiveData,
                  receiveList: sortedRecevieList,
                  row,
                  showBtn,
                  delReceiveList,
                  setDelReceiveList,
                  setReceiveList,
                  contractBaseInfo,
                }}
              />
            </section>
          )}
          {(row.original.bill.pgcode === "creditcard" || row.original.bill.pgcode === "virtualaccount") && (
            <section>
              <div className="base-abstract-modal__contents-subtitle">
                <div className="flex-center">
                  <h2>{row.original.bill.pgcode === "creditcard" ? "카드결제 내역" : "간편 입금 계좌 내역"}</h2>
                  <p className="font14 pl10">총 {paymentArray.length} 건</p>
                </div>
              </div>
              <PaymentTable
                dataBundle={{
                  paymentData: paymentArray,
                  pgcode: row.original.bill.pgcode,
                  editable: showBtn,
                  callList,
                  callPaymentList,
                  // getAccountAndPaymentInfo,
                  scheduleId,
                }}
              />
            </section>
          )}
          {/* 수납 처리 */}
          <section>
            <div className="base-abstract-modal__contents-subtitle">
              <div className="flex-center">
                <h2>수납 처리</h2>
              </div>
              {row.original.bill.pgcode === "banktransfer" && (
                <ul>
                  <li>입금내역 선택 후 수납내역의 입금액을 해당 회차의 청구금액으로 수정가능합니다.</li>
                </ul>
              )}
            </div>

            <StorageProcessingTable
              dataBundle={{
                sortedRecevieList,
                showBtn,
                receiveData,
                setReceiveData,
                makeSum,
                makeOvSum,
                row,
                setReceiveList,
                paymentArray,
                delReceiveList,
                setDelReceiveList,
                contractBaseInfo,
              }}
            />
          </section>
        </div>
      </article>

      <BaseModal
        isOpen={isSave}
        btnLeftTitle="취소"
        btnRightTitle="확인"
        onClose={() => setIsSave(false)}
        onClick={() => makeSuccess(sortedRecevieList, delReceiveList)}
        title={message}
      ></BaseModal>
      <BaseModal isOpen={isSaved} btnRightTitle="확인" onClick={() => setIsSaved(false)} title={message}></BaseModal>

      <section className="base-abstract-modal__btn-wrap">
        {showBtn && row.original.bill.billPayStatus !== "PAYMENT_SUCCESS" ? (
          <>
            <BaseButton
              title={"취소"}
              className="color-white"
              onClick={() => {
                setIsChange(false);
              }}
            />
            <BaseButton
              title={"저장"}
              onClick={() => {
                validation(sortedRecevieList);
              }}
            />
          </>
        ) : (
          <BaseButton
            title={"확인"}
            onClick={() => {
              setIsChange(false);
            }}
          />
        )}
      </section>
    </BaseAbstractModal>
  );
};

export default StorageProcessingModal;
